import React from "react";
import "./MasskaraLoading.css";

interface Props {
  isOpen: boolean;
  backdrop?: boolean;
}

const MasskaraLoading: React.FC<Props> = ({ isOpen, backdrop = true }) => {
  if (!isOpen) return null;

  return (
    <div className={`masskara-backdrop ${backdrop ? "on" : "off"}`}>
      <div className="masskara-loader">
        <div className="spinner-ring"></div>
        <img src="assets/ai-avatar.png" alt="Loading" className="masskara-icon" />
      </div>
    </div>
  );
};

export default MasskaraLoading;
